import { WappMode } from '@weblite-wapps/protocol'
import { wappSystemApi } from '../setup/root'
import { wappView } from '../wapprunner-pool/wapprunnerPool.reducer'

export const sendWappLoadingTimeAnalytics = ({
  wappSessionId,
  duration,
}: {
  wappSessionId: string
  duration: number
}) => {
  const { wappId, wisId } = wappView(wappSessionId)
  const wappVersion = wappSystemApi?.getWappVersion?.(wappId)

  analite('WAPP_LOAD', { d: duration, wi: wappId, si: wisId, wappVersion })
}

export const sendWappRunningTimeAnalytics = ({
  wappSessionId,
  duration,
}: {
  wappSessionId: string
  duration: number
}) => {
  const { wappId, wisId, mode } = wappView(wappSessionId)
  const durationInSeconds = Math.round(duration / 1000)
  const minifiedMode = mode?.[0].toUpperCase()
  const wappVersion = wappSystemApi?.getWappVersion?.(wappId)

  if (mode !== WappMode.INLINE || durationInSeconds >= 3)
    analite('WAPP_TIME', {
      d: durationInSeconds,
      wi: wappId,
      si: wisId,
      m: minifiedMode,
      wappVersion,
    })
}
